var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":_vm.returnPage}},[_vm._v("返回")]),_c('div',{staticClass:"demo-image__lazy"},[_c('el-image',{attrs:{"src":_vm.url,"lazy":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }